import { getRequest } from '@/core';
import { globalAddresses } from '@/requests';

export default async function getFilteredGlobalAddressesRequest(filter) {
	let url = globalAddresses.getPath();
	try {
		let response = await getRequest(url, filter);
		return response;
	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}
